export const URLS = {
  ipLocation: "/v2/profiles/me/iplocation",
} as const;
